import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import style from "./product-description-header.css";

function ProductDescriptionHeader(_ref) {
  var className = _ref.className,
      designerName = _ref.designerName,
      designerUrl = _ref.designerUrl,
      isDesignerActive = _ref.isDesignerActive,
      shortDescription = _ref.shortDescription;
  return React.createElement("div", {
    className: classnames(className, style.wrapper)
  }, React.createElement("div", {
    className: style.titleWrapper
  }, React.createElement("h1", {
    className: style.title
  }, React.createElement("div", {
    className: style.designerName
  }, isDesignerActive && designerUrl ? React.createElement("a", {
    href: designerUrl,
    className: style.designerLink
  }, designerName) : React.createElement("span", null, designerName)), React.createElement("span", {
    className: style.shortDescription
  }, " " + shortDescription))));
}

ProductDescriptionHeader.defaultProps = {
  isDesignerActive: false
};
ProductDescriptionHeader.propTypes = {
  absoluteUrl: PropTypes.string,
  className: PropTypes.string,
  designerName: PropTypes.string.isRequired,
  designerUrl: PropTypes.string,
  isDesignerActive: PropTypes.bool,
  productId: PropTypes.string,
  shortDescription: PropTypes.string.isRequired
};
export default ProductDescriptionHeader;